import "whatwg-fetch";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import App from "./App";
const rootContainer = document.getElementById("navigationbar");
if (rootContainer) {
    const render = (Component) => ReactDOM.render((React.createElement(AppContainer, null,
        React.createElement(Component, Object.assign({}, (rootContainer.dataset))))), rootContainer);
    render(App);
    if (module.hot) {
        module.hot.accept("./App", () => {
            const NextApp = require("./App");
            render(NextApp);
        });
    }
}
